import * as React  from 'react';
import {
    Accordion,
    Button, Card, CardActions, CardContent,
    Checkbox,
    Chip,
    Container,
    Divider,
    FormControl,
    FormControlLabel,
    InputLabel, Modal,Grid,Autocomplete
} from "@mui/material";
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from '@mui/material/Select';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TextField from "@mui/material/TextField";
import {DataGrid, GridColDef, GridRenderCellParams} from '@mui/x-data-grid';
import 'react-dates/lib/css/_datepicker.css';
import 'react-dates/initialize';
import SideBar from "../../componets/sideBar/sideBar";
import Box from '@mui/material/Box';
import * as Yup from "yup";
import { Formik, Form, Field, FieldArray,FormikErrors } from 'formik';
import ListItemText from '@mui/material/ListItemText';
// @ts-ignore
import {DateRangePicker, FocusedInputShape} from "react-dates";
import {
    getReport,
    addReport,
    updateReport,
    IReport,
    listReport,
    ReportSelector,
    startEditLoading,
    finishEditLoading,
    disabledReport,
    resetReport,
    IReportPost, IReportConvert,changeFinish_date,changeStart_date
} from "../../store/report";
import {unwrapResult} from "@reduxjs/toolkit";
import {AxiosError} from "axios";
import {openNotifier} from "../../store/notifier";
import {useAppDispatch} from "../../store/store";
import FormGroup from '@mui/material/FormGroup';

import {
    getVehicleType,
    getVehicleTypeBrand,
    ITypeVehicle,
    VehiclesSelector,
    ITypeVehicleBrand,
    listVehicles,
    resetTypeVehiclesBrand, getVehicle, IBrandVehicle, resetVehicle, initialState, IVehicle, addVehicle
} from "../../store/vehicles";
import {getGuides, guideSelector, getSchedule, IGuide,ISchedule} from "../../store/guides";
import {useSelector} from "react-redux";
import moment from 'moment';
import dayjs, {Dayjs} from "dayjs";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import MinimizeIcon from '@mui/icons-material/Minimize';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import FormHelperText from '@mui/material/FormHelperText';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import CheckIcon from '@mui/icons-material/Check';
import EditIcon from '@mui/icons-material/Edit';

const validationSchema = Yup.object().shape({
    operations: Yup.array().of(
        Yup.object().shape({
            isFirst: Yup.boolean(),
            fchOperacion:Yup.date()
                .when('isFirst', (first, schema) => {
                    return first[0]
                        ? schema.required('Fecha es requerida')
                        : schema.notRequired();
                }),
            idHorario: Yup.number()
                .when('isFirst', (first, schema) => {
                    return first[0]
                        ? schema.required('ID de Horario es requerido').min(1, 'ID de Horario debe ser mayor a 0')
                        : schema.notRequired();
                }),
            vehiculos: Yup.array()
                .when('isFirst', (first, schema) => {

                    return first[0]
                        ?schema.of(
                            Yup.object().shape({
                                idVehiculo: Yup.array().of(Yup.number()).required('Required')
                                    .min(1, 'Debe seleccionar al menos un vehículo')
                                    .required('ID de Vehículo es requerido'),
                                idGuia: Yup.number().required('ID de Guia es requerido').min(1, 'ID de Tipo de Guia debe ser mayor a 0'),
                                isResponsable:Yup.boolean(),
                                idTipo_vehiculo: Yup.number().required('ID de Tipo de Vehículo es requerido').min(1, 'ID de Tipo de Vehículo debe ser mayor a 0'),
                                intAdulto: Yup.number().notRequired(),
                                intMenor: Yup.number().notRequired(),
                            })
                        ).test('at-least-one-responsible', 'Al menos un vehículo debe tener un responsable', function (vehiculos) {
                            if (!vehiculos || vehiculos.length === 0) return false;
                            return vehiculos.some(vehiculo => vehiculo.isResponsable);
                        })
                        : schema.of(
                        Yup.object().shape({
                            idVehiculo: Yup.array().of(Yup.number()).required('Required')
                                .min(1, 'Debe seleccionar al menos un vehículo')
                                .required('ID de Vehículo es requerido'),
                            idGuia: Yup.number().required('ID de Guia es requerido'),
                            isResponsable:Yup.boolean().notRequired(),
                            idTipo_vehiculo: Yup.number().required('ID de Tipo de Vehículo es requerido').min(1, 'ID de Tipo de Vehículo debe ser mayor a 0'),
                            intAdulto: Yup.number().required('Número de adultos es requerido').min(1, 'Número de adultos debe ser mayor a  1'),
                            intMenor: Yup.number().required('Número de menores es requerido').min(0, 'Número de menores debe ser mayor o igual a 0'),
                        })
                    )
                }).required('Vehículos es requerido'),
            incidenciasVehiculos:Yup.array().of( Yup.object().shape({
                idTipo_vehiculo: Yup.number().required('ID de Tipo de Vehículo es requerido').min(1, 'ID de Tipo de Vehículo debe ser mayor a 0'),
                idVehiculo: Yup.array().of(Yup.number()).required('Required')
                    .min(1, 'Debe seleccionar al menos un vehículo')
                    .required('ID de Vehículo es requerido'),
                strIncidenciaVehiculo: Yup.string().nullable(),
                })),
            strDes_operacion: Yup.string().nullable(),
            strIncidencia: Yup.string().nullable(),
        })
    ).required('Operaciones son requeridas'),
});



interface Vehiculo {
    idVehiculo: number[];
    idGuia: number;
    isResponsable:boolean
    idTipo_vehiculo: number;
    intAdulto?: number;
    intMenor?: number;
}

interface Operation {
    isFirst?:boolean
    fchOperacion?: string;
    dateOperation?: any; // Puede ser de tipo 'Dayjs' si estás usando 'dayjs'
    idHorario: number;
    vehiculos: Vehiculo[];
    strDes_operacion: string;
    strIncidencia: string;
}

interface FormValues {
    operations: Operation[];
}

const initialValues: FormValues = {
    operations: [
        {
            isFirst: true,
            fchOperacion: dayjs().format('YYYY-MM-DD'),
            dateOperation: dayjs(),
            idHorario: 0,
            vehiculos: [
                {
                    idVehiculo: [],
                    idGuia: 0,
                    idTipo_vehiculo: 0,
                    intAdulto: 0,
                    intMenor: 0,
                    isResponsable: false
                }
            ],
            strDes_operacion: "",
            strIncidencia: ""
        },
        {
            isFirst: false,
            idHorario: 0,
            vehiculos: [
                {
                    idVehiculo: [],
                    idGuia: 0,
                    idTipo_vehiculo: 0,
                    intAdulto: 0,
                    intMenor: 0,
                    isResponsable: false
                }
            ],
            strDes_operacion: "",
            strIncidencia: ""
        }
    ],
};


function ReporteTour() {
    const [open, setOpen] = React.useState(false);
    const [isUpdateReport, setUpdateReport] = React.useState(false);
    const [openAccordion, setOpenAccordion] = React.useState(true);
    const [openFormGuia, setFormGuia] = React.useState(true);
    const [openIncidencia, setIncidencia] = React.useState(false);
    const [loadVehicles, setLoadVehicles] = React.useState(false);
    const [expanded, setExpanded] = React.useState<number | false>(0);
    const [selectedVehicles, setSelectedVehicles] = React.useState<number[]>([]);
    // Estado para almacenar los guías seleccionados
    const [selectedGuide, setSelectedGuide] = React.useState<IGuide | null>(null);
    const [selectedHorario, setSelectedHorario] = React.useState<ISchedule | null>(null);
    const [focusedInput, setFocusedInput] = React.useState<FocusedInputShape | null>(null);
    const dispatch = useAppDispatch();
    const {guides,loadingGuide,schedules,loadingSchedule} = useSelector(guideSelector);
    const {typeVehiclesBrand,typeVehicles} = useSelector(VehiclesSelector);
    const {      meta: {
        current_page,
        per_page,
        total,

    },reports,loading,loadingEdit,report, filters: {
        start_date,
        finish_date,
    }} = useSelector(ReportSelector);


    const columns: GridColDef[] = [
        { field: 'fchOperacion', headerName: 'Fecha',  },
        { field: 'strHorario', headerName: 'Horario',  },
        { field: 'strGuia', headerName: 'Guia',  width:250,
            renderCell: (params: GridRenderCellParams) => (
                <>
                    {params?.row?.strGuia??'Visitante'}
                </>
            ),
        },
        { field: 'idTour_operacion', headerName: 'Vehículo', width: 150},
        {
            field: 'intAdulto',
            headerName: 'Adultos',
            width: 80,
        },{
            field: 'intMenor',
            headerName: 'Niños',
            width: 80
        },
        {
            field: 'actions',
            headerName: '',
            flex: 1,
            sortable: false,
            renderCell: (params: GridRenderCellParams) => (
                <>
                    <Button
                        className="btnEdit"
                        variant="contained"
                        color="primary"
                        size="small"
                        style={{ marginRight: 8 }}
                        onClick={() =>{
                            window.scrollTo({
                                top: 0,
                                behavior: 'smooth',
                            });

                            dispatch(getReport({id:params?.row?.idTour_operacion})).then(unwrapResult).then((result: any) => {
                                setOpen(true);
                                setUpdateReport(true)
                                dispatch(startEditLoading())
                            }).catch((result: AxiosError) => {
                                // @ts-ignore
                                dispatch(openNotifier({variant: "error", open: true, message: result?.message}))
                            })


                        }}
                    >
                        <EditIcon style={{marginRight:5}}/> Editar
                    </Button>
                    <Button
                        className={`${params?.row?.intEstado ?'btnDeshabilitar':'btnHabilitar'}`}
                        variant="contained"
                        color={"secondary"}
                        size="small"
                        style={{ marginRight: 8 }}
                        onClick={() =>
                            dispatch(disabledReport({id:params?.row?.idTour_operacion,currentPage:current_page}))
                        }
                    >
                        {
                            params?.row?.intEstado ?<><DoDisturbIcon style={{marginRight:5}}/> Deshabilitar</>:<><CheckIcon style={{marginRight:5}}/> Habilitar</>
                        }
                    </Button>
                </>
            ),
        },
    ];
    const handleCheckboxChange = (
        event: React.ChangeEvent<HTMLInputElement>,
        id: number,
        opIndex: number,
        vehIndex: number,
        setFieldValue: (field: string, value: any) => void,
        values: any
    ) => {
        const updatedVehicles = event.target.checked
            ? [...values.operations[opIndex].vehiculos[vehIndex].idVehiculo, id]
            : values.operations[opIndex].vehiculos[vehIndex].idVehiculo.filter((vehicleId: number) => vehicleId !== id);
        setFieldValue(`operations.${opIndex}.vehiculos.${vehIndex}.idVehiculo`, updatedVehicles);
    };
    const isVehicleSelectedElsewhere = (id: number, opIndex: number, vehIndex: number, values: FormValues) => {
        return values.operations.some((operation, operationIndex) => {
            return operation.vehiculos.some((vehiculo, vehiculoIndex) => {
                return (operationIndex !== opIndex || vehiculoIndex !== vehIndex) && vehiculo.idVehiculo.includes(id);
            });
        });
    };
    const isResponsableSelectedElsewhere = (opIndex: number, values: FormValues) => {
        return values.operations.some((operation, index) =>{
                return operation.vehiculos.some((vehiculo,numIndex) => {
                    return  opIndex!==numIndex&&vehiculo.isResponsable
                })
            }
        );
    };

    const errorVehicles=(errors:FormikErrors<FormValues>,index:number,numIndex:number)=>{

        let errorMessage=''
        // @ts-ignore
                        if(errors?.operations?.[index]?.vehiculos?.[numIndex]?.idVehiculo){
                            // @ts-ignore
                            errorMessage=errors?.operations?.[index]?.vehiculos?.[numIndex]?.idVehiculo
                        }
        // @ts-ignore
                        if(errors?.operations?.[index]?.vehiculos==='Al menos un vehículo debe tener un responsable'){
                            errorMessage='Al menos un vehículo debe tener un responsable'
                        }


                return <span className={'textError'}>{errorMessage}</span>
    }

    const getSelectedGuides = (values: FormValues, currentOperationIndex:number, currentVehiculoIndex:number) => {
        return values.operations.reduce((acc:number[], operation, operationIndex) => {
            if (operationIndex !== currentOperationIndex) {
                operation.vehiculos.forEach((vehiculo) => {
                    if (vehiculo.idGuia !== 0) {
                        acc.push(vehiculo.idGuia);
                    }
                });
            } else {
                operation.vehiculos.forEach((vehiculo, vehiculoIndex) => {
                    if (vehiculoIndex !== currentVehiculoIndex && vehiculo.idGuia !== 0) {
                        acc.push(vehiculo.idGuia);
                    }
                });
            }
            return acc;
        }, []);
    };


    const transformData = (data:IReportConvert) => {
        const operation1: Operation = {
            isFirst: true,
            fchOperacion: dayjs(data.fchOperacion).format('YYYY-MM-DD'),
            dateOperation: dayjs(data.fchOperacion),
            idHorario: data.idHorario,
            vehiculos: [],
            strDes_operacion: data.strDes_operacion===null?'':data.strDes_operacion,
            strIncidencia:  data.strIncidencia===null?'':data.strIncidencia,
        };

        const operation2: Operation = {
            isFirst: false,
            fchOperacion: dayjs(data.fchOperacion).format('YYYY-MM-DD'),
            dateOperation: dayjs(data.fchOperacion),
            idHorario: data.idHorario,
            vehiculos: [],
            strDes_operacion: data.strDes_operacion===null?'':data.strDes_operacion,
            strIncidencia: data.strIncidencia===null?'':data.strIncidencia,
        };

        const groupByTypeAndGuide = (vehicles: {
            idVehiculo: number;
            idGuia: number | null;
            intAdulto?: number;
            intMenor?: number;
            idTiposVehiculo: number;
            isResponsable: boolean;
        }[], operation: Operation) => {
            const groupedVehicles: { [key: number]: Vehiculo } = {};

            vehicles.forEach(vehicle => {
                const type = vehicle.idTiposVehiculo;

                // Si idGuia no es null o 0, se crea un nuevo objeto para cada vehículo
                if (vehicle.idGuia && vehicle.idGuia !== 0) {
                    operation.vehiculos.push({
                        idVehiculo: [vehicle.idVehiculo],
                        idGuia: vehicle.idGuia || 0,
                        idTipo_vehiculo: type,
                        intAdulto: vehicle?.intAdulto,
                        intMenor: vehicle?.intMenor,
                        isResponsable: !!vehicle?.isResponsable,
                    });
                } else {
                    // Si idGuia es null o 0, se agrupan los vehículos por tipo
                    if (!groupedVehicles[type]) {
                        groupedVehicles[type] = {
                            idVehiculo: [],
                            idGuia: 0, // No hay guía en este caso
                            idTipo_vehiculo: type,
                            intAdulto: vehicle?.intAdulto,
                            intMenor: vehicle?.intMenor,
                            isResponsable: false, // No es responsable si no hay guía
                        };
                    }
                    groupedVehicles[type].idVehiculo.push(vehicle.idVehiculo);
                }
            });

            // Agregar los vehículos agrupados (donde idGuia es null o 0)
            operation.vehiculos.push(...Object.values(groupedVehicles));
        };


        // @ts-ignore
        const vehiclesWithGuide = data.pax.flatMap(p =>
            p.vehicles
                // @ts-ignore
                .filter(vehicle => vehicle.idGuia && vehicle.idGuia !== 0)
                // @ts-ignore
                .map(vehicle => ({
                    ...vehicle,
                    intAdulto: p.intAdulto,
                    intMenor: p.intMenor
                }))
        );

        // @ts-ignore
        const vehiclesWithoutGuide = data.pax.flatMap(p =>
            p.vehicles
                // @ts-ignore
                .filter(vehicle => !vehicle.idGuia || vehicle.idGuia === 0)
                // @ts-ignore
                .map(vehicle => ({
                    ...vehicle,
                    intAdulto: p.intAdulto,
                    intMenor: p.intMenor
                }))
        );

        groupByTypeAndGuide(vehiclesWithGuide, operation1);
        groupByTypeAndGuide(vehiclesWithoutGuide, operation2);
        console.log(operation1)
        return {
            operations: [operation1, operation2],
        };
    };
    const UpdateComponent: React.FC<{ setFieldValue: (field: string, value: any) => void,values:any,isUpdate:boolean }> = ({ setFieldValue,values,isUpdate }) => {


        React.useEffect(() => {

            if(isUpdateReport){
                const transformedData = transformData(report);

                setFieldValue('operations', transformedData?.operations);
                setUpdateReport(false)
            }

        }, [report]);

        return null;
    };
    const handleAccordionChange = (panel: number) => (
        event: React.ChangeEvent<{}>,
        isExpanded: boolean
    ) => {

        setExpanded(isExpanded ? panel : false);
    };
    React.useEffect(() => {


            dispatch(getGuides({}))

    }, []);
    React.useEffect(() => {

        dispatch(getSchedule({}))
    }, []);

    React.useEffect(() => {
        setSelectedVehicles([])
        dispatch(resetTypeVehiclesBrand())

    }, []);
    React.useEffect(() => {

            if(typeVehiclesBrand.length<=0){
                dispatch(getVehicleTypeBrand({}))
                dispatch(getVehicleType({}))
            }
    }, [typeVehiclesBrand]);

    React.useEffect(() => {
        dispatch(getVehicleType({}))
        dispatch(listReport({page: 1, items: 10}))
    }, []);
    const handleClose = () => {
        setOpen(false)
        dispatch(resetReport())
        dispatch(finishEditLoading())

    };


    React.useEffect(() => {
        dispatch(getVehicleTypeBrand({}))
    }, []);

    return (
        <>
            <Container maxWidth="xl" className="contLayout mt-30">
                <Typography variant="h1" className="titleBody txt-dark" gutterBottom>Agregar Operación</Typography>
                <Typography variant="h2" className="subtitleBody txt-green" gutterBottom>Filtrar por:</Typography>
                <div className="pageReporte mt-30">
                    <SideBar></SideBar>
                    <div style={{marginBottom:45}}>
                        <Accordion defaultExpanded={openAccordion} onClick={()=>{
                            setOpenAccordion(!openAccordion)
                        }}>
                            <AccordionSummary
                                expandIcon={openAccordion?<MinimizeIcon />:<AddIcon />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                            >
                                <Typography className="subtitleBody ">Agregar Operación</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Formik
                                    initialValues={initialValues}
                                    validationSchema={validationSchema}
                                    onSubmit={ (values,{resetForm}) => {

                                         const newValues:IReportPost={
                                             fchOperacion:values?.operations?.[0]?.fchOperacion,
                                             idHorario: values?.operations?.[0]?.idHorario,
                                             strDes_operacion: values?.operations?.[0]?.strDes_operacion,
                                             strIncidencia:values?.operations?.[0]?.strIncidencia,
                                             vehiculos: values?.operations?.flatMap((operacion,index) =>
                                                 values?.operations?.[index].vehiculos.flatMap(vehicle =>
                                                     vehicle.idVehiculo.map(id => ({
                                                         intAdulto:vehicle?.intAdulto,
                                                         intMenor:vehicle?.intMenor,
                                                         idTipo_vehiculo:vehicle?.idTipo_vehiculo,
                                                         details:[
                                                             {
                                                                 idVehiculo: id,
                                                             idGuia: vehicle.idGuia,
                                                             isResponsable: vehicle.isResponsable},
                                                         ],
                                                     }))
                                                 )
                                             )
                                         }

                                        if(loadingEdit){

                                            dispatch(updateReport({report:newValues,id:report?.idTour_operacion,currentPage:current_page})).then(unwrapResult).then((result: any) => {
                                                resetForm();
                                                setFormGuia(true);
                                                dispatch(finishEditLoading())
                                                dispatch(resetTypeVehiclesBrand())
                                                handleClose()
                                            }).catch((result: AxiosError) => {
                                                // @ts-ignore
                                                dispatch(openNotifier({variant: "error", open: true, message: result?.message}))
                                            })


                                        } else {

                                            dispatch(addReport({report:newValues})).then(unwrapResult).then((result: any) => {
                                                resetForm()
                                                setFormGuia(true)
                                                dispatch(finishEditLoading())
                                                dispatch(resetTypeVehiclesBrand())
                                                handleClose()
                                            }).catch((result: AxiosError) => {
                                                // @ts-ignore
                                                dispatch(openNotifier({variant: "error", open: true, message: result?.message}))
                                            })
                                        }
                                    }}
                                >

                                    {({ values,setFieldValue,submitForm,errors,dirty,touched,setSubmitting,resetForm,setTouched }) => (
                                        <Form>
                                            <div className={`cont-btn-chip `}>
                                                <Chip label="Guias"  onClick={()=>{
                                                    setIncidencia(false)
                                                    setFormGuia(true)
                                                    dispatch(resetVehicle())
                                                }} className={`btn-chip ${(!openFormGuia)&&(!(Object.keys(errors).length === 0) && !dirty) ? 'bg-error' :  ''}  ${((!!touched?.operations?.[1]) &&(!!errors.operations && errors.operations[1]) && !openFormGuia)?'clase activa':'clase no activa'}  ${openFormGuia?'bg-green txt-white':''}`}/>
                                                <Chip label="Visitantes" variant="outlined" onClick={()=>{
                                                    setIncidencia(false)
                                                    setFormGuia(false)
                                                    // dispatch(resetTypeVehiclesBrand())
                                                }} className={`btn-chip ${(openFormGuia)&&(!(Object.keys(errors).length === 0) && !dirty) ? 'bg-error' :  ''} ${((!!touched?.operations?.[0]) &&(!!errors.operations && errors.operations[0]) && openFormGuia)?'clase activa':'clase no activa'} ${openFormGuia?'':'bg-green txt-white'}`}/>
                                                {/*<Chip label="Incidencias de Vehiculos" variant="outlined" onClick={()=>{*/}
                                                {/*    setFormGuia(false)*/}
                                                {/*    setIncidencia(true)*/}
                                                {/*}} className={`btn-chip bg-green-Dark txt-white`}/>*/}
                                            </div>
                                            <div>

                                                <div className="">

                                                    <UpdateComponent values={values?.operations} setFieldValue={setFieldValue} isUpdate={loadingEdit}/>
                                                    <div>
                                                        {
                                                            openFormGuia &&  <div className="cont-form-reporte-vehiculo">
                                                                {/* FECHA */}
                                                                <div>
                                                                    <FormControl fullWidth>
                                                                        <LocalizationProvider
                                                                            dateAdapter={AdapterDayjs}
                                                                            adapterLocale={'en'}
                                                                        >
                                                                            <DatePicker
                                                                                format={'DD-MM-YYYY'}
                                                                                value={values?.operations?.[0]?.dateOperation}
                                                                                onChange={(value, context)=>
                                                                                {

                                                                                    setFieldValue(`operations[0].dateOperation`, value).then()
                                                                                    setFieldValue(`operations[0].fchOperacion`, value?.format('YYYY-MM-DD')).then()
                                                                                }
                                                                                }
                                                                                label="Fecha" />
                                                                        </LocalizationProvider>
                                                                    </FormControl>
                                                                </div>
                                                                {/* HORARIO */}
                                                                <div>
                                                                    <FormControl fullWidth error={!!errors?.operations &&  (errors?.operations?.[0] as any)?.idHorario  && !!touched?.operations?.[0]?.idHorario}>
                                                                        <InputLabel id="idSelectHorario">Horario</InputLabel>
                                                                        <Select
                                                                            labelId="idSelectHorario"
                                                                            id="demo-simple-select"

                                                                            value={values?.operations[0]?.idHorario}
                                                                            label="Horario"
                                                                            onChange={(event, child)=>{

                                                                                setFieldValue(`operations[0].idHorario`, event?.target?.value??1).then()
                                                                            }}
                                                                        >
                                                                            {/*<MenuItem value={0}></MenuItem>*/}

                                                                            {
                                                                                schedules.filter(Boolean).map((schedule:ISchedule)=>
                                                                                    <MenuItem value={schedule.id}  key={schedule.id}>{schedule.timeHora}</MenuItem>
                                                                                )
                                                                            }
                                                                        </Select>
                                                                    </FormControl>
                                                                </div>
                                                            </div>

                                                        }
                                                        {
                                                            openFormGuia &&   <div className="cont-form-reporte-vehiculo col-2-100">
                                                                <div>
                                                                    <FormControl fullWidth error={!!errors?.operations && (errors?.operations[0] as any)?.strDes_operacion && !!touched?.operations?.[0]?.strDes_operacion}>
                                                                        <TextField
                                                                            id="txtComentario"
                                                                            value={values?.operations[0]?.strDes_operacion}
                                                                            label="Comentario"
                                                                            multiline
                                                                            onChange={(event)=>{
                                                                                setFieldValue(`operations[0].strDes_operacion`, event.target.value??'').then()
                                                                            }}

                                                                            rows={4}
                                                                            fullWidth
                                                                        />
                                                                    </FormControl>
                                                                </div>

                                                                <div>
                                                                    <FormControl fullWidth error={!!errors?.operations &&  (errors?.operations[0] as any)?.strIncidencia && !!touched?.operations?.[0]?.strIncidencia}>
                                                                        <TextField
                                                                            id="txtIncidencia"
                                                                            label="Incidencias"
                                                                            value={values?.operations[0]?.strIncidencia}
                                                                            multiline
                                                                            onChange={(event)=>{
                                                                                setFieldValue(`operations[0].strIncidencia`, event?.target?.value??'').then()
                                                                            }}
                                                                            rows={4}
                                                                            fullWidth
                                                                        />
                                                                    </FormControl>
                                                                </div>
                                                            </div>
                                                        }

                                                        <div>
                                                            <div className="">
                                                                <div className="">
                                                                    {
                                                                        !openIncidencia && <FieldArray name="operations">
                                                                            {({ push, remove, form }) => (
                                                                                <>
                                                                                    {values.operations.map((operation, index) => (
                                                                                        <FieldArray name={`operations[${index}.vehiculos`}>
                                                                                            {({ push: pushVehicle,remove:removeVehicle }) => (
                                                                                                <>
                                                                                                    {operation?.vehiculos.map((vehiculo, numIndex) => (
                                                                                                        ((index===0&&openFormGuia)||(index===1 && !openFormGuia)) &&(
                                                                                                            <Accordion
                                                                                                                className={`${!!errors?.operations && (errors?.operations[index] as any)?.vehiculos?.[numIndex]  && !!touched?.operations?.[index]?.vehiculos?.[numIndex]?'AccordeonIndexError':'AccordeonIndex'}`}
                                                                                                                key={numIndex}
                                                                                                                expanded={expanded === numIndex}
                                                                                                                onChange={handleAccordionChange(numIndex)}
                                                                                                            >
                                                                                                                <AccordionSummary
                                                                                                                    expandIcon={<ExpandMoreIcon />}
                                                                                                                    aria-controls="panel1-content"
                                                                                                                    id={`panel${numIndex}-header`}
                                                                                                                >
                                                                                                                    <strong className="tituloAccordeon">{numIndex+1} - {index===0?"Operador":"Visitante"}: {index===0?guides.find((guide:IGuide) => guide.id===values?.operations[index]?.vehiculos[numIndex]?.idGuia)?.name ??'':undefined}
                                                                                                                        {index===1?typeVehicles.find((typeVehicle:ITypeVehicle) => typeVehicle.id===values?.operations[index]?.vehiculos[numIndex]?.idTipo_vehiculo)?.name ??'':undefined}
                                                                                                                        <span className={`${guides.find((guide:IGuide) => (guide.id===values?.operations[index]?.vehiculos[numIndex]?.idGuia) && values?.operations[index]?.vehiculos[numIndex]?.isResponsable)?'responsable':''}`}>
                                                                                                                    {guides.find((guide:IGuide) => (guide.id===values?.operations[index]?.vehiculos[numIndex]?.idGuia) && values?.operations[index]?.vehiculos[numIndex]?.isResponsable)? '' +
                                                                                                                        '(Responsable)' : undefined}
                                                                                                                   </span>
                                                                                                                    </strong>
                                                                                                                </AccordionSummary>
                                                                                                                <AccordionDetails>
                                                                                                                    <div  key={numIndex} className="contAddReporte">
                                                                                                                        <div className="col-2-100">
                                                                                                                            {/* GUIAS */}
                                                                                                                            {
                                                                                                                                (openFormGuia && index===0) &&     <div>
                                                                                                                                    <FormControl fullWidth error={!!errors?.operations && (errors?.operations[index] as any)?.vehiculos?.[numIndex]?.idGuia  && !!touched?.operations?.[index]?.vehiculos?.[numIndex]?.idGuia}>

                                                                                                                                        <InputLabel id={`idInputGuia${numIndex}`}>Guia</InputLabel>
                                                                                                                                        <Select
                                                                                                                                            labelId={`idInputGuia${numIndex}`}
                                                                                                                                            id={`selectGuia${numIndex}`}
                                                                                                                                            value={values?.operations[index]?.vehiculos[numIndex]?.idGuia}
                                                                                                                                            label="Guia"
                                                                                                                                            onChange={(event, child)=>{
                                                                                                                                                setFieldValue(`operations[${index}].vehiculos[${numIndex}].idGuia`, event.target.value ?? 1).then()
                                                                                                                                            }}
                                                                                                                                        >
                                                                                                                                            {/*<MenuItem value={0}></MenuItem>*/}
                                                                                                                                            {/*{*/}
                                                                                                                                            {/*    guides.filter(Boolean).map((guide:IGuide)=>*/}
                                                                                                                                            {/*        <MenuItem value={guide.id}  key={guide.id}>{guide.name}</MenuItem>*/}
                                                                                                                                            {/*    )*/}
                                                                                                                                            {/*}*/}
                                                                                                                                            {
                                                                                                                                                guides
                                                                                                                                                    .filter(Boolean)
                                                                                                                                                    .map((guide: IGuide) =>
                                                                                                                                                        <MenuItem value={guide.id} key={guide.id}  disabled={getSelectedGuides(values, index, numIndex).includes(guide.id)}>{guide.name}</MenuItem>
                                                                                                                                                    )
                                                                                                                                            }
                                                                                                                                        </Select>
                                                                                                                                    </FormControl>
                                                                                                                                </div>
                                                                                                                            }
                                                                                                                            {/* TIPO VEHICULO */}
                                                                                                                            {((index === 0 && openFormGuia) || (index === 1 && !openFormGuia)) && (
                                                                                                                                <div>
                                                                                                                                    <FormControl fullWidth error={!!errors?.operations &&  (errors?.operations[index] as any)?.vehiculos?.[numIndex]?.idTipo_vehiculo  && !!touched?.operations?.[index]?.vehiculos?.[numIndex]?.idTipo_vehiculo}>
                                                                                                                                        <InputLabel id={`InputidTipoVehiculoLabel${numIndex}`}>Tipo de Vehículo</InputLabel>
                                                                                                                                        <Select
                                                                                                                                            labelId={`InputidTipoVehiculoLabel${numIndex}`}
                                                                                                                                            id={`IdTipoVehiculoLabel${numIndex}`}
                                                                                                                                            label="Tipo de Vehículo"
                                                                                                                                            value={values?.operations[index]?.vehiculos[numIndex]?.idTipo_vehiculo}
                                                                                                                                            onChange={(event, child)=>{
                                                                                                                                                // setFieldValue("idTipo_vehiculo", event.target.value??1).then()

                                                                                                                                                setFieldValue(`operations[${index}].vehiculos[${numIndex}].idTipo_vehiculo`, event.target.value ?? 1).then()
                                                                                                                                                // dispatch(getVehicleTypeBrand({idTipoVehiculo:+event.target.value??1}))
                                                                                                                                                setLoadVehicles(true)

                                                                                                                                            }}
                                                                                                                                        >
                                                                                                                                            {/*<MenuItem value={0}></MenuItem>*/}
                                                                                                                                            {
                                                                                                                                                typeVehicles.filter(Boolean).map((typeVehicle:ITypeVehicle)=>
                                                                                                                                                    <MenuItem value={typeVehicle.id}  key={typeVehicle.id}>{typeVehicle.name}</MenuItem>
                                                                                                                                                )
                                                                                                                                            }
                                                                                                                                        </Select>
                                                                                                                                    </FormControl>
                                                                                                                                </div>
                                                                                                                            )
                                                                                                                            }
                                                                                                                            {
                                                                                                                                (index===0 && openFormGuia) && (
                                                                                                                                    <FormGroup>
                                                                                                                                        <FormControlLabel
                                                                                                                                            onChange={(event, checked)=>{

                                                                                                                                                setFieldValue(`operations.${index}.vehiculos.${numIndex}.isResponsable`, checked).then()
                                                                                                                                            }}
                                                                                                                                            checked={values.operations[index].vehiculos[numIndex].isResponsable}
                                                                                                                                            disabled={isResponsableSelectedElsewhere(numIndex,values)}
                                                                                                                                            control={<Checkbox />}
                                                                                                                                            label="Responsable" />
                                                                                                                                        {
                                                                                                                                            ((!!errors?.operations &&  (errors?.operations[index] as any)?.vehiculos?.[numIndex]?.isResponsable) && !!touched?.operations?.[index]?.vehiculos?.[numIndex]?.isResponsable) &&   <FormHelperText>Be careful</FormHelperText>
                                                                                                                                        }

                                                                                                                                    </FormGroup>
                                                                                                                                )
                                                                                                                            }

                                                                                                                            <div className="col-2-100">
                                                                                                                                {
                                                                                                                                    (!openFormGuia && index===1) && <FormControl fullWidth >
                                                                                                                                        <TextField fullWidth id="outlined-basic-int-adult" label="Adultos" error={!!errors.operations && errors.operations[index] ? (errors.operations[index] as any).vehiculos?.[numIndex]?.intAdulto : '' && !!touched?.operations?.[index]?.vehiculos?.[numIndex]?.intAdulto} variant="outlined" value={values?.operations[index]?.vehiculos[numIndex]?.intAdulto} onChange={(event)=>{
                                                                                                                                            setFieldValue(`operations[${index}].vehiculos[${numIndex}].intAdulto`, event.target.value??1).then()
                                                                                                                                        }} /></FormControl>
                                                                                                                                }
                                                                                                                                {
                                                                                                                                    (!openFormGuia && index===1) && <TextField fullWidth id="outlined-basic-intMenos" label="Niños" variant="outlined"  value={values?.operations[index]?.vehiculos[numIndex]?.intMenor} onChange={(event)=>{
                                                                                                                                        setFieldValue(`operations[${index}].vehiculos[${numIndex}].intMenor`, event.target.value??1).then()
                                                                                                                                    }} />
                                                                                                                                }
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                        {
                                                                                                                            ((values?.operations[index]?.vehiculos.length >1 && (index === 0 && openFormGuia) )|| (index === 1 && !openFormGuia) ) &&  <div className="btnRemove"
                                                                                                                                                                                                                                                            onClick={() => removeVehicle(numIndex)}
                                                                                                                            >{/* clase para remover btnRemove */}
                                                                                                                                <RemoveIcon/>
                                                                                                                            </div>
                                                                                                                        }
                                                                                                                        {/*<Divider className="divider"/>*/}
                                                                                                                    </div>
                                                                                                                    <div className="contCheckVehiculo">
                                                                                                                        {
                                                                                                                            typeVehiclesBrand.filter(Boolean).filter((vehicle:ITypeVehicleBrand)=>vehicle.idTiposVehiculo===values?.operations[index]?.vehiculos[numIndex]?.idTipo_vehiculo).map((vehicle:ITypeVehicleBrand)=>{
                                                                                                                                const isChecked = values.operations[index].vehiculos[numIndex].idVehiculo.includes(vehicle.idVehiculo);
                                                                                                                                const isIncluded = isVehicleSelectedElsewhere(vehicle.idVehiculo, index, numIndex, values);

                                                                                                                                const isDisabled = index === 0
                                                                                                                                    ? (values.operations[index].vehiculos[numIndex].idVehiculo.length > 0 && !isChecked) || isIncluded
                                                                                                                                    : isIncluded;

                                                                                                                                return <div className="shadow">
                                                                                                                                    <FormControlLabel
                                                                                                                                        value={vehicle.idVehiculo}
                                                                                                                                        key={vehicle.idVehiculo}
                                                                                                                                        control={<Checkbox />}
                                                                                                                                        checked={values.operations[index].vehiculos[numIndex].idVehiculo.includes(vehicle.idVehiculo)}
                                                                                                                                        onChange={(event,checked) => {
                                                                                                                                            handleCheckboxChange(event as React.ChangeEvent<HTMLInputElement>, vehicle.idVehiculo, index, numIndex, setFieldValue, values)
                                                                                                                                        }}
                                                                                                                                        disabled={isDisabled}
                                                                                                                                        label={vehicle.strName}
                                                                                                                                        className="check-vehiculo"

                                                                                                                                    /><span className="marca">{vehicle?.strMarca}</span></div>
                                                                                                                            })
                                                                                                                        }

                                                                                                                    </div>
                                                                                                                    {
                                                                                                                        (errorVehicles(errors,index,numIndex))
                                                                                                                    }
                                                                                                                    {/*{*/}
                                                                                                                    {/*    (errors?.operations?.[index] as FormikErrors<Operation>)?.vehiculos?.[numIndex]?.idVehiculo*/}
                                                                                                                    {/*        ? <div>{(errors?.operations?.[index] as FormikErrors<Operation>)?.vehiculos?.[numIndex]?.idVehiculo}</div>*/}
                                                                                                                    {/*        : null*/}
                                                                                                                    {/*}*/}
                                                                                                                </AccordionDetails>
                                                                                                            </Accordion>
                                                                                                        )

                                                                                                    ))}
                                                                                                    {
                                                                                                        ((index === 0 && openFormGuia) || (index === 1 && !openFormGuia)) &&(
                                                                                                            <div className="btnAdd"
                                                                                                                 onClick={() => {
                                                                                                                     pushVehicle({ idVehiculo:[], idGuia: 0,idTipo_vehiculo:0,intAdulto:0,intMenor:0,isResponsable:false })
                                                                                                                     setExpanded(values.operations[index]?.vehiculos.length);
                                                                                                                 }}
                                                                                                            >{/* clase para remover btnRemove */}
                                                                                                                <AddIcon/> Agregar {index===0?'Guia':'Visitante'}
                                                                                                                {/*<RemoveIcon/>*/}
                                                                                                            </div>
                                                                                                        )
                                                                                                    }
                                                                                                </>
                                                                                            )}
                                                                                        </FieldArray>
                                                                                    ))}
                                                                                </>
                                                                            )}
                                                                        </FieldArray>
                                                                    }


                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="cont-btn-reporte">
                                                {/*<Button className="btn-ghost" onClick={()=>{}}><AddIcon/> Desglose de Operación</Button>*/}
                                                {/*<Button className="btn-ghost"><AddIcon/> Incidencias</Button>*/}
                                                <Button className="btn-full-cancel" style={{width:'200px',backgroundColor:"red!important"}} onClick={()=>{
                                                    setTouched({},false)
                                                    resetForm()
                                                    dispatch(finishEditLoading())
                                                    dispatch(resetReport())

                                                }}>Cancelar</Button>
                                                {
                                                    <Button className="btn-full" style={{width:'200px'}} onClick={()=>{

                                                        const allFieldsFilled = Object.keys(errors).length === 0 && dirty;

                                                        if(!loadingEdit){
                                                            submitForm().then()

                                                        }

                                                        if(allFieldsFilled && !loadingEdit){


                                                        } else{

                                                            openFormGuia ? setFormGuia(false) : setFormGuia(true);
                                                        }
                                                    }}>

                                                        {((Object.keys(errors).length === 0 && dirty)&& !loadingEdit) ? 'Guardar' : openFormGuia ? 'Siguiente' : 'Anterior'}

                                                    </Button>
                                                }
                                                {
                                                    loadingEdit&& <Button className="btn-full" style={{width:'200px'}} onClick={()=>{

                                                        submitForm().then()

                                                    }}>
                                                        Editar

                                                    </Button>
                                                }
                                            </div>
                                        </Form>
                                    )}
                                </Formik>
                            </AccordionDetails>
                        </Accordion>

                        <Divider className="divider"/>

                        <div className="cont-vehiculos-registrados mt-30">
                            <Typography
                                gutterBottom
                                component="h4"
                                style={{
                                    fontWeight: "600"
                                }}
                            > Filtrar por: </Typography>

                            <Grid container spacing={2} style={{gridGap: '15px 0'}}>
                                {/* Columna para el DateRangePicker */}
                                <Grid item xs={12} md={6}>
                                    <div className="cont-center">
                                        <Typography variant="overline" display="block" gutterBottom>
                                            Rango de Fecha:
                                        </Typography>


                                        <DateRangePicker
                                            startDate={start_date !== null ? moment(start_date) : start_date}   //    start_date ? moment(start_date, 'YYYY-MM-DD') : moment()
                                            endDate={finish_date !== null ? moment(finish_date) : finish_date}  //    finish_date ? moment(finish_date, 'YYYY-MM-DD') : moment()
                                            startDateId='daterangepicker_start_date'
                                            displayFormat='DD/MM/YYYY'
                                            startDateAriaLabel='Fecha de Entrada'
                                            minimumNights={0}
                                            isOutsideRange={() => false}
                                            hideKeyboardShortcutsPanel
                                            endDateId='daterangepicker_end_date'
                                            onDatesChange={(value: {
                                                startDate: moment.MomentInput;
                                                endDate: moment.MomentInput;
                                            }) => {
                                                if (moment.isMoment(value.startDate) && start_date !== value.startDate.format('YYYY-MM-DD')) {
                                                    dispatch(changeStart_date(value.startDate.format('YYYY-MM-DD')));

                                                }
                                                if (moment.isMoment(value.endDate) && finish_date !== value.endDate.format('YYYY-MM-DD')) {
                                                    dispatch(changeFinish_date(value.endDate.format('YYYY-MM-DD')));

                                                }
                                            }}
                                            focusedInput={focusedInput}
                                            onFocusChange={(focusedInput: FocusedInputShape | null) => {
                                                setFocusedInput(focusedInput)
                                            }
                                            }
                                        />

                                    </div>

                                </Grid>
                                {/* Columna para los horarios Autocomplete */}
                                <Grid item xs={12} md={6}>
                                    <div className="cont-center">
                                        <Typography variant="overline" display="block" gutterBottom>
                                          Horarios:
                                        </Typography>
                                        <Autocomplete
                                            id="tags-standard"
                                            options={schedules}
                                            value={selectedHorario} // Ahora es un objeto IGuide
                                            onChange={(_, newValue) => setSelectedHorario(newValue)} // Guarda todo el objeto
                                            getOptionLabel={(option) => option.timeHora} // Muestra el nombre en el input
                                            renderOption={(props, option) => (
                                                <li {...props}>{option.timeHora}</li> // Solo muestra el nombre
                                            )}
                                            renderInput={(params) => (
                                                <TextField {...params} variant="outlined" placeholder="Horarios" />
                                            )}
                                        />
                                    </div>
                                </Grid>

                                {/* Columna para el guias */}
                                <Grid item xs={12} md={6}>
                                    <div className="cont-center">
                                        <Typography variant="overline" display="block" gutterBottom>
                                            Guías:
                                        </Typography>
                                    </div>
                                    <Autocomplete
                                        id="tags-standard"
                                        options={guides}
                                        value={selectedGuide} // Ahora es un objeto IGuide
                                        onChange={(_, newValue) => setSelectedGuide(newValue)} // Guarda todo el objeto
                                        getOptionLabel={(option) => option.name} // Muestra el nombre en el input
                                        renderOption={(props, option) => (
                                            <li {...props}>{option.name}</li> // Solo muestra el nombre
                                        )}
                                        renderInput={(params) => (
                                            <TextField {...params} variant="outlined" placeholder="Guías" />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <div className="cont-center">
                                        <Button className="btn-full-orange"
                                                disabled={(selectedGuide===null&& selectedHorario===null&&start_date===null&&finish_date===null)}
                                                style={{width:'118px'}}
                                                onClick={()=>{
                                                    dispatch(listReport({
                                                    page: 1,
                                                    items: 10,
                                                    start_date:start_date,
                                                    end_date:finish_date,
                                                    name:selectedGuide?.name,
                                                    id_horario:selectedHorario?.id
                                                    }))
                                        }}>
                                            Aplicar filtros
                                        </Button>

                                    </div>
                                </Grid>



                            </Grid>


                            <Typography variant="h3" className="subtitleBody txt-dark" gutterBottom>Vehículos
                                Registrados</Typography>
                            <DataGrid
                                className="tbl-vehiculos mt-20"
                                getRowId={(row) => row?.idTour_operacion + Math.random()}
                                rows={reports}
                                columns={columns}
                                initialState={{
                                    pagination: {
                                        paginationModel: {page: 0, pageSize: 5},
                                    },
                                }}
                                loading={loading}
                                disableColumnFilter
                                disableColumnSelector
                                disableDensitySelector
                                rowCount={total}
                                sortingMode={'client'}
                                filterMode={'server'}
                                paginationMode={'server'}
                                pageSizeOptions={[5, 10]}
                                onPaginationModelChange={(model, details) => {
                                    if (current_page !== model.page + 1) dispatch(listReport({
                                        page: (model.page + 1),
                                        items: model.pageSize
                                    }));
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Container>
        </>
    );
}

export default ReporteTour;
